import { combineReducers } from "redux";
import testReducer from "./testReducer";
import { alertMessage } from "./messageBar/alertMessageReducer";
import { loading } from "./loading/loadingReducer";
import horsesReducer from "./horses/horsesReducer";
import { tableReducer } from "./table/tableReducer";

const reducers = combineReducers({
    alertMessage,
    loading,
    test: testReducer,
    horsesReducer,
    tableConfig: tableReducer
});

export default reducers;